import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Layout, Menu } from 'antd';
import 'antd/dist/antd.css';
import { SiderProps } from 'antd/lib/layout/Sider';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { publicUrl } from '@utils/env';
import { routes, RouteProps } from '@lib/routes';
import { useTranslation } from 'react-i18next';
import { AiOutlineMenuFold, AiOutlineMenuUnfold } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import store, { RootState } from 'app/store';
import { updateActiveMenuHeader, updateIsCollapseNav } from '@slice/select.slice';
import AdminLogApi from 'apis/api/AdminLog';
import { updateUserAccountingPermission, updateUserAccountingPermissionUserAccountTax } from '@slice/user.slice';

type Props = SiderProps;

function SiderComponent(props: Props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useNavigate();
  const selectedTheme = useSelector((state: RootState) => state.select.themeSelected);
  const activeMenuHeader = useSelector((state: RootState) => state.select.activeMenuHeader);
  const collapsed = useSelector((state: RootState) => state.select.isCollapsedNav);
  const routesFilter = useSelector((state: RootState) => state.user.routesFilter);

  const uLogin = useSelector((state: RootState) => state.user.account);
  const userAccountTax = useSelector((state: RootState) => state.user.userAccountTax);
  const isFirstRun = useRef(true);
  const getConfigWithKey = async () => {
    try {
      const res = await AdminLogApi.GetConfigWithKey('UserCanCollectCash');
      if (!res.data.error) {
        const allowedUsers = res.data.data.data ? res.data.data.data.split(',') : [];
        const checkAuth = !!(uLogin?.username && allowedUsers.includes(uLogin.username));
        // Đẩy vào Redux, hàm lọc sẽ tự chạy lại và hiện menu
        dispatch(updateUserAccountingPermission(checkAuth));
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getConfigWithKeyV2 = async () => {
    try {
      const res = await AdminLogApi.GetConfigWithKey('UserAccountTax');
      if (!res.data.error) {
        const allowedUsers = res.data.data.data ? res.data.data.data.split(',') : [];
        const checkAuth = uLogin?.username && allowedUsers.includes(uLogin.username);

        dispatch(updateUserAccountingPermissionUserAccountTax(checkAuth));

        // CHỈ THỰC HIỆN REDIRECT NẾU LÀ LẦN ĐẦU TIÊN

        // const currentPath = window.location.pathname;

        console.log('checkAuth', uLogin.username, checkAuth);
        if (checkAuth) {
          // Nếu vào root hoặc login thì mới đẩy đi, còn nếu F5 tại trang khác thì kệ họ

          history('/bao-cao-theo-don-hang');
        }
        // else {
        // Không có quyền mà cố tình ở trang Tax thì đẩy ra

        //   history('/');
        // }
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getConfigWithKeyV2();
    if (uLogin?.username && !['Admin', 'Root'].includes(uLogin?.role)) {
      getConfigWithKey();
    }
  }, [uLogin?.role, uLogin?.username]);

  const handleTo = (pathname?: string) => () => {
    console.log('pathname', pathname);
    if (pathname) {
      history(pathname);
    }
  };

  // const handleChange = (e, pathname?: string) => {
  //   if ((e.button === 0 && e.ctrlKey) || e.button === 1) {
  //     console.log('ContextMenu', publicUrl + pathname);
  //     // window.open(publicUrl + pathname, '_blank', 'location=no');
  //     window.open(publicUrl + pathname);
  //   }
  // };

  const handleChange = (e, pathname?: string) => {
    e.preventDefault(); // CHẶN Firefox tự mở tab
    e.stopPropagation(); // CHẶN bubble làm mở thêm tab
    const isOpenNewTab = (e.button === 0 && e.ctrlKey) || e.button === 1;
    console.log('key new tab', e, pathname);

    if (isOpenNewTab && pathname) {
      window.open(publicUrl + pathname, '_blank');
    }
  };

  const handleContextMenu = (pathname?: string) => () => {
    console.log('ContextMenu', publicUrl + pathname);
    // window.open(publicUrl + pathname, '_blank', 'location=no');
    // window.open(publicUrl + pathname);
    // const anchor = document.createElement('a');
    // anchor.href = publicUrl + pathname;
    // document.body.appendChild(anchor);
    // const evt = document.createEvent('MouseEvents');
    // // the tenth parameter of initMouseEvent sets ctrl key
    // evt.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, true, false, false, false, 0, null);
    // anchor.dispatchEvent(evt);
  };

  const onClick = (props: any) => {
    // const storeRedux = store.getState().select;
    // const dataMenuKeys = {
    //   keysMenu: props.key && props.key,
    //   openTabs: props.keyPath && props.keyPath
    // };
    // console.log('onClick', props, dataMenuKeys);
    // storeRedux && dispatch(updateActiveMenuHeader(dataMenuKeys));
  };

  const renderMenuItem = (routeC: RouteProps | any) => {
    // console.log('child: ', routeC.key);
    if (routeC.hiddenSider || (routesFilter && routesFilter.includes(routeC.key))) {
      return null;
    }
    return (
      <>
        {/* <Menu.Item
          key={routeC.key.toString()}
          disabled={routeC.disabled}
          icon={routeC.Icon ? <routeC.Icon /> : null}
          onClick={handleTo(routeC.url)}
          // onContextMenu={handleContextMenu(routeC.url)}
          onMouseDown={e => handleChange(e, routeC.url)}
        >
          <Link
            to={routeC.url}
            // onClick={() => {
            //   //
            // }}
            onMouseDown={e => {
              if ((e.button === 0 && e.ctrlKey) || e.button === 1) {
                e.preventDefault(); // CHẶN FIREFOX TỰ MỞ TAB
                e.stopPropagation();
                return; // KHÔNG CHO BROWSER NHẢY VÀO <a>
              }
            }}
          >
            {t(routeC.title)}
          </Link>
        </Menu.Item> */}

        <Menu.Item
          key={routeC.key.toString()}
          disabled={routeC.disabled}
          icon={routeC.Icon ? <routeC.Icon /> : null}
          onClick={(e: any) => {
            if ((e.button !== 0 && !e.ctrlKey) || e.button !== 1) {
              handleTo(routeC.url);
            }
          }}
          onMouseDown={e => handleChange(e, routeC.url)}
        >
          <Link
            to={routeC.url}
            onMouseDown={e => {
              if ((e.button === 0 && e.ctrlKey) || e.button === 1) {
                // CHẶN FIREFOX TỰ MỞ TAB
                console.log('key tab name 123', e);
                e.preventDefault();
                e.stopPropagation();
              }
            }}
          >
            {routeC.title === 'Menu.Dashboard' ? (
              <span className="font-medium">{t(routeC.title).toLocaleUpperCase()}</span>
            ) : (
              t(routeC.title)
            )}
          </Link>
        </Menu.Item>
        {routeC.dividerLine && <Menu.Divider />}
      </>
    );
  };

  const activeMenu = useMemo(() => {
    console.log('activeMenu', activeMenuHeader);
    if (activeMenuHeader) {
      return activeMenuHeader;
    }
    return { keysMenu: 'dashboard-page', openTabs: [undefined] };
  }, [activeMenuHeader]);

  const clickToLogo = () => {
    dispatch(updateActiveMenuHeader(undefined));
    if (userAccountTax) {
      history('/bao-cao-theo-don-hang');
    } else {
      history('/');
    }
  };

  // console.log('routesFilter', routes);
  return (
    <ThemeWrapper
      theme={selectedTheme}
      {...props}
      width={'200px'} // mức cố định có thể làm động nếu cần, k nên sửa vì sửa thì cần custom lại các vị trí footer box
      trigger={null}
      collapsible
      collapsed={collapsed}
      onCollapse={value => {
        dispatch(updateIsCollapseNav(value));
      }}
      collapsedWidth={40}
    >
      {!collapsed ? (
        <div className="flex justify-between items-center px-2">
          <Logo onClick={clickToLogo}>
            <img width={32} src={`${publicUrl}/logo_adsun_only.png`} />
            <div className="font-medium">ADSUN-OM</div>
          </Logo>

          <div>
            <WapperButtom theme={selectedTheme} onClick={() => dispatch(updateIsCollapseNav(!collapsed))}>
              {collapsed ? <AiOutlineMenuUnfold size={16} /> : <AiOutlineMenuFold size={16} />}
            </WapperButtom>
          </div>
        </div>
      ) : (
        <Logo onClick={clickToLogo}>
          <img width={32} src={`${publicUrl}/logo_adsun_only.png`} />
        </Logo>
      )}

      <WrapperMenu collapsed={collapsed}>
        <ListMenu
          mode="inline"
          defaultSelectedKeys={activeMenu?.keysMenu}
          defaultOpenKeys={activeMenu?.openTabs}
          selectedKeys={activeMenu?.keysMenu}
          onClick={onClick}
          theme="light"
          className="hidden-scroll"
        >
          {routes.map(route => {
            if (route.hiddenSider || routesFilter.includes(route.key)) {
              return null;
            }
            return !route.children ? (
              renderMenuItem(route)
            ) : (
              <Menu.SubMenu
                key={route.key.toString()}
                icon={<route.Icon rev={''} />}
                title={<span className="font-medium">{t(route.title).toLocaleUpperCase()}</span>}
              >
                {route.children.map(c => renderMenuItem(c))}
              </Menu.SubMenu>
            );
          })}
        </ListMenu>
      </WrapperMenu>
    </ThemeWrapper>
  );
}

const Sider = styled(Layout.Sider)`
  &.ant-layout-sider {
    height: 100vh;
    position: fixed;
    left: 0;
    overflow: hidden;
    overflow-x: hidden;
    overflow-y: hidden;
  }
  .ant-menu-vertical .ant-menu-item::after,
  .ant-menu-vertical-left .ant-menu-item::after,
  .ant-menu-vertical-right .ant-menu-item::after,
  .ant-menu-inline .ant-menu-item::after {
    left: 0;
    right: unset !important;
  }
  .ant-menu-root {
    overflow-x: hidden;
  }
  .ant-menu-inline.ant-menu-root .ant-menu-submenu-title {
    padding-left: 12px !important;
  }
  .ant-menu-inline.ant-menu-root .ant-menu-item {
    padding-left: 12px !important;
  }
  .ant-menu-submenu > .ant-menu-sub > li > ul {
    .ant-menu-item {
      padding-left: 22px !important;
    }
  }
  .ant-menu-title-content {
    user-select: none;
  }
  .ant-menu-item-active {
    background-color: #d3d3d3;
  }
  .ant-menu-sub.ant-menu-inline .ant-menu-item {
    padding-left: 18px !important;
  }
  .ant-menu-sub.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
    padding-left: 18px !important;
  }
  .ant-menu-inline,
  .ant-menu-vertical,
  .ant-menu-vertical-left {
    border-right: none !important;
  }
`;

// cấu hình các thứ cho menu nav bar tại đây
const ThemeWrapper = styled(Sider)<{ theme?: any }>`
  z-index: 10;
  background-color: ${({ theme }) => theme.colors!.background};
  color: ${({ theme }) => theme.colors!.text};
  .ant-menu {
    color: ${({ theme }) => theme.colors.text};
    background: ${({ theme }) => theme.colors!.background};
    font-family: 'Roboto';
    font-size: 13.5px;
  }
  .ant-menu-sub.ant-menu-inline {
    color: ${({ theme }) => theme.colors!.text};
    background: ${({ theme }) => theme.colors!.dimBackground};
  }
  .ant-menu-item a,
  .ant-menu-submenu-arrow {
    color: unset;
  }
`;

const WrapperMenu = styled.div<{ collapsed?: any }>`
  height: ${({ collapsed }) => (collapsed ? 'calc(93vh)' : 'calc(93vh)')};
`;

const ListMenu = styled(Menu)`
  height: calc(100% - 0px);
  overflow-y: auto;
`;

const WapperButtom = styled.div.attrs({
  className: 'cursor-pointer p-1 hover:bg-blue-400 hover:text-white rounded-full'
})<{ theme?: any }>`
  background-color: ${({ theme }) => theme.colors!.background};
  color: ${({ theme }) => theme.colors!.text};
`;

const Logo = styled.div`
  height: 45px;
  display: flex;
  position: block;
  align-items: center;
  justify-content: center;
  color: #1890ff;
  cursor: pointer;
`;

SiderComponent.displayName = 'Sider';

export default SiderComponent;
